<template>
    <div class="v-modal">
        <div class="v-modal__header">
            <span>Sector or Crop Selection</span>
            <div @click="cancel()" class="close"></div>
        </div>
        <div class="v-modal__body">
            <Errors @dismiss="errors = []" :errors="errors"/>
            <div class="row">
                <div v-if="!validate" class="col-md-3 p-card" @click="changeModel(100001)">
                    <div
                            class="box"
                            v-bind:class="{ active: crop.level2 == null }"
                    >
                        <div class="box__title">All Sectors</div>
                        <img src="../../assets/img/pie-chart.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div class="col-md-3 p-card" @click="changeModel(10001)">
                    <div
                            class="box"
                            v-bind:class="{ active: crop.level2 == 10001 }"
                    >
                        <div class="box__title">Agriculture</div>
                        <img src="../../assets/img/icons/crop_for_selector.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div class="col-md-3 p-card" @click="changeModel(10002)">
                    <div
                            class="box"
                            v-bind:class="{ active: crop.level2 == 10002 }"
                    >
                        <div class="box__title">Industry</div>
                        <img src="../../assets/img/icons/industry.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div v-if="!validate" class="col-md-3 p-card" @click="changeModel(10003)">
                    <div
                            class="box"
                            v-bind:class="{ active: crop.level2 == 10003 }"
                    >
                        <div class="box__title">Domestic</div>
                        <img src="../../assets/img/icons/domestic-water.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>

                <template v-if="level3Crops.length">
                <div v-if="!validate" class="col-md-6 mb-2">
                    <div class="form-group form-check">
                        <input id="selection-section" type="checkbox" :checked="showCropSelectionSection" @change="changeSpecific" class="form-check-input"/>
                    <label for="selection-section" class="form-check-label">{{checkboxLabel}}</label>
                    </div>
                </div>
                    <template v-if="!!validate || showCropSelectionSection">
                <div class="col-md-6 mb-3">
                    <multiselect
                            :options="selectOptions"
                            :show-labels="false"
                            placeholder="Search crop or material"
                            label="name"
                            track-by="cropID"
                            @select="changeModel"
                    ></multiselect>
                </div>
                        <div class="col-md-6">
                            <div class="category">{{level3Header}}</div>
                        </div>
                        <div class="col-md-6">
                            <div class="crop" v-if="level4Crops.length">{{level4Header}}</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <ul class="category__list">
                                <li
                                        class="list-item"
                                        v-for="crop1 of level3Crops"
                                        v-bind:key="crop1.cropID"
                                        @click="changeModel(crop1)"
                                        v-bind:class="{ active: crop.level3 === crop1.cropID}"
                                >{{ crop1.name }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6 mb-2">
                            <ul class="category__list" v-if="level4Crops.length">
                                <li
                                        class="list-item"
                                        v-for="crop1 of level4Crops"
                                        v-bind:key="crop1.cropID"
                                        v-bind:class="{ active: crop.level4 === crop1.cropID }"
                                        @click="changeModel(crop1)"
                                >{{ crop1.name }}
                                </li>
                            </ul>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div v-if="!validate" class="v-modal__footer">
            <button @click="close()" class="btn btn-primary">Close</button>
        </div>
        <div v-else-if="!!commit" class="v-modal__footer justify-content-between">
            <button @click="close()" class="btn btn-primary">
                <span class="fa fa-chevron-left"></span> Cancel
            </button>
            <button @click="selectOrNext()" class="btn btn-primary">Select</button>
        </div>
        <div v-else class="v-modal__footer">
            <button @click="selectOrNext()" class="btn btn-primary">Next</button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import { assessment } from "@/services/assessment-model";
    import {crops, getCrop} from "@/services/entity-model.js";
    import { closeModal } from "@/services/modal-model";
    import Errors from "@/components/shared/Errors.vue";

    export default {
        name: "Crop",
        components: {
            Errors,
            Multiselect
        },
        props: {
            modal: {type: Object},
            tempCrop: { type: Object },
            setCrop: {type: Function},
            validate: {type: Function},
            commit: {type: Function},
            nextStep: { type: Boolean, default: false }
        },
        data() {
            return {
                errors: [],
                crop: this.tempCrop || getCrop(10001),
                selectOptions: crops.filter(crop => crop.level >= 3),
                showCropSelectionSection: (this.tempCrop || getCrop(10001)).level >= 3
            };
        },
        methods: {
            cancel() {
                this.close();
                if (this.nextStep) {
                    assessment.setAssessmentType(null);
                }
            },
            changeModel: function (value) {
                if (typeof value == "number") {
                    this.crop = getCrop(value);
                } else {
                    this.crop = value;
                }
                if (this.setCrop != null) {
                  this.setCrop(this.crop);
                }
                if (this.crop.level == 2) {
                    this.showCropSelectionSection = false;
                }
                this.errors = [];
            },
            changeSpecific: function (event) {
                if (event.target.checked) {
                    this.showCropSelectionSection = true;
                } else {
                    this.changeModel(this.crop.level2);
                }
            },
            selectOrNext() {
                const error = this.validate(this.crop);
                if (error == null) {
                    if (this.commit != null) {
                        this.commit(this.crop);
                    } else {  // this.nextStep == true
                        assessment.setCrop(this.crop);
                        assessment.nextStep();
                    }
                    this.close();
                } else {
                    this.errors = [error];
                }
            },
            close() {
                closeModal(this.modal);
            }
        },
        computed: {
            checkboxLabel() {
                return "Select a specific " + ((this.crop.level2 == 10001)? "crop or category": "material");
            },
            level3Header() {
                return (this.crop.level2 == 10001)? "Crop Categories": "Material Groups";
            },
            level4Header() {
                return getCrop(this.crop.level3).name;
            },
            level3Crops() {
                return crops.filter(crop => (crop.level == 3) && (crop.level2 == this.crop.level2));
            },
            level4Crops() {
                return crops.filter(crop => (crop.level == 4) && (crop.level3 == this.crop.level3));
            }
        }
    };
</script>

<style lang="scss" scoped>
    .p-card {
        height: 120px;
        margin-bottom: 30px;
        cursor: pointer;

        &--icon {
            position: absolute;
            left: 50%;
            top: 10%;
            transform: translateX(-50%);
        }

        .box {
            display: flex;
            position: relative;
            height: 100%;
            border-radius: 25px;
            overflow: hidden;
            justify-content: flex-end;
            flex-direction: column;

            &__title {
                position: absolute;
                bottom: 7%;
                z-index: 11;
                width: 100%;
                color: white;
                text-align: center;
                font-size: 16px;
            }

            &:hover {
                box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.24);
            }
            &.active {
                border: 2px solid #009bd1;
            }
        }

        .mask {
            z-index: 10;
            height: 100px;
            background-size: cover;
            background-image: url("../../assets/img/shape.png");
        }
    }

    .form-check {
        padding-top: 8px;
    }

    .list-item {
        padding-left: 5px;
        cursor: pointer;

        &:nth-child(even) {
            background: #edebe5;
        }

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 25px;
        line-height: 25px;
        color: #707070;

        &:hover {
            background: #009bd1;
            color: white;
        }

        &.active {
            background-color: #009bd1;
            color: white;
        }
    }

    .category {
        font-size: 18px;
        margin-bottom: 5px;

        &__list {
            max-height: 252px;
            overflow-y: auto;
            margin-bottom: 0;
            padding: 0;
            list-style: none;
            border: 1px solid #edebe5;
        }

        &::before {
            position: relative;
            top: 0;
            content: url("../../assets/img/category.png");
            margin-right: 5px;
            margin-left: 5px;
        }

        &__header {
            cursor: pointer;
            margin-bottom: 20px;
        }
    }

    .crop {
        font-size: 18px;
        margin-bottom: 5px;

        &::before {
            position: relative;
            top: 0;
            content: url("../../assets/img/crop.png");
            margin-right: 5px;
            margin-left: 5px;
        }

        &__header {
            cursor: pointer;
            margin-bottom: 20px;
        }
    }
</style>
